export default __webpack_public_path__ + "static/media/error-light.af6bbc28.svg";